export const ADMIN_CREDENTIALS = {
  username: 'admin',
  password: '12345QWERTY!',
}
